import React from 'react';
import HelpRequiredPopup from './helpRequiredPopup';

class ImageLink extends React.PureComponent {
    constructor(props, context) {
        super(props, context);

        this.handleClose = this.handleClose.bind(this);

        this.state = {
            show: false
        };
    }

    handleClose() {
        this.setState({ show: false });
    }

    setVisibilityOfPopup() {
        if (!this.props.featureActive && this.props.enablePopup) {
            this.setState({ show: true });
        }
    }

    render() {
        return (
            <div className="grid-link">         
                <div className="icon-image">
                    <a
                        href={this.props.featureActive ? this.props.url : '#'}
                        title={this.props.title}
                        onClick={() => this.setVisibilityOfPopup()}
                    >
                        <img className={this.props.isSVG ? "svg-img" : ""}
                            src={this.props.imageSrc}
                            alt={this.props.altText}
                            height={this.props.imgHeight}
                            width={this.props.imgWidth}
                        />
                    </a>
                </div>
                <div className="icon-text">
                    <a
                        href={this.props.featureActive ? this.props.url : '#'}
                        title={this.props.title}
                        onClick={() => this.setVisibilityOfPopup()}
                    >
                        {this.props.children}
                    </a>
                </div>
                
                <HelpRequiredPopup
                    CSRRepTitle={this.props.CSRRepTitle}
                    show={this.state.show}
                    handleClose={this.handleClose}
                />
            </div>);
    }
}
export default ImageLink;
